import React, {useState, useEffect} from "react";
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import AuthUpdateForm from "./AuthUpdateForm";

import firebase from '../../Firebase';
import 'firebase/database';




const AuthUpdate = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();

  const [authInfo, setAuthInfo] = useState(null);

  const loadData = (auth_id) => {

    firebase.database().ref(`/auth/`).once('value').then(function(snapshot) {
      if (snapshot.child(auth_id).exists()){

        var childData = snapshot.child(auth_id).val();

        setAuthInfo({
          auth_id: auth_id,
          backend_url: childData.backend_url,
          caregiver_id: childData.caregiver_id,
          caregiver_name: childData.caregiver_name,
          facility_id: childData.facility_id,
          facility_name: childData.facility_name,
          password: childData.password,
          isActive : childData.isActive,
          isOnlySleep: childData.isOnlySleep,
          listDevicesForSleep: childData.listDevicesForSleep
        });
      }
    });
  }


  useEffect( () => {
    loadData(match.params.auth_id);
    return () => { };
  }, []);


  return (
    <div className={classes.root}>
      <div className={classes.content}>
        { authInfo && <AuthUpdateForm authInfo={authInfo} history={history} /> }
      </div>
    </div>
  );
};


AuthUpdate.propTypes = {
  history: PropTypes.object
};


export default withRouter(AuthUpdate);


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));

